import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  CategoryFacet,
  CategoryFacetState,
  RegularFacet,
  RegularFacetState,
  Unsubscribe,
} from '@coveo/headless/commerce';

@Component({
  selector: 'app-search-bar-facet',
  templateUrl: './search-bar-facet.component.html',
  styleUrls: ['./search-bar-facet.component.scss'],
})
export class SearchBarFacetComponent implements OnInit, OnDestroy {
  @Input() controller: RegularFacet | CategoryFacet;
  @Output() showSearchFacetEmitter = new EventEmitter<boolean>();
  @Output() searchSelectFacetEmitter = new EventEmitter<string>();
  stateUnsubscribe: Unsubscribe;
  state: RegularFacetState | CategoryFacetState;
  isTyping = false;
  showSearchFacet = false;
  showEmptyResult = false;
  searchText: string;

  ngOnInit() {
    this.stateUnsubscribe = this.controller.subscribe(() => {
      this.state = this.controller.state;
      if (
        this.showSearchFacet &&
        this.state?.facetSearch?.values.length === 0
      ) {
        this.showEmptyResult = true;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.stateUnsubscribe) {
      this.stateUnsubscribe();
    }
    this.searchText = '';
  }

  trackFacetValueId(index: number, facetValue: any) {
    return facetValue.value;
  }

  handleInputChangeFacet(evt) {
    this.searchText = evt?.target?.value?.trim();
    if (this.searchText === '') {
      this.showSearchFacet = false;
      this.showEmptyResult = false;
      this.showSearchFacetEmitter.emit(false);
      this.controller.facetSearch.clear();
      return;
    }

    this.controller.facetSearch.updateText(this.searchText);
    this.controller.facetSearch.search();
    this.showSearchFacetEmitter.emit(true);
    this.showSearchFacet = true;
  }

  setIsTyping(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.isTyping = !!input?.value?.trim();
  }

  public handleCheckboxSelection(value: any): void {
    this.controller.facetSearch.select(value);
    this.controller.facetSearch.clear();
    this.showSearchFacet = false;
    this.searchSelectFacetEmitter.emit(this.state?.facetId);
  }
}
